import { createSlice } from '@reduxjs/toolkit';
import { initialState } from '@store/constants';

import * as copyActions from './actions/copyActions';
import * as couponActions from './actions/couponActions';
import * as etcActions from './actions/etcActions';
import * as giftActions from './actions/giftActions';
import * as prepaidActions from './actions/prepaidCardActions';

export const orderSlice = createSlice({
    name: 'order',
    initialState,
    reducers: {
        ...couponActions,
        ...copyActions,
        ...etcActions,
        ...giftActions,
        ...prepaidActions,
    },
});

export const orderActions = orderSlice.actions;

export default orderSlice.reducer;
